import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators'
import { GlobalService } from './global.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
const devUrl = environment.backendurl;

@Injectable({
  providedIn: 'root'
})
export class WebbtreeVerifiedService {

  constructor(private http: HttpClient) { }

  getRequestContract(requestObject: any): Observable<any> {
    let url = devUrl + "/personsearch/premiumenrichment";
    return this.http.post<any>(url, requestObject).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Error while making contract request', url)));
  }

}
